// van Gelder Inc. — Resource Center guides (maintenance & installation).
// EDIT THIS FILE to add, rename, or recategorize downloadable guides.

export const GUIDE_TYPES = ["Installation", "Maintenance"];

export const guides = [
  // ---------- Installation ----------
  {
    title: "Carpet Tile Installation",
    type: "Installation",
    description: "Step-by-step guidelines for installing van Gelder carpet tile.",
    pdf: "/docs/guides/carpet-tile-installation.pdf",
  },
  {
    title: "Sheet Goods Installation",
    type: "Installation",
    description: "Installation instructions for broadloom sheet & roll goods.",
    pdf: "/docs/guides/sheet-goods-installation.pdf",
  },
  {
    title: "Natural Coco Installation",
    type: "Installation",
    description: "How to install Natural Coco/Coir matting in recessed wells.",
    pdf: "/docs/guides/natural-coco-installation.pdf",
  },
  {
    title: "Nature's View Installation Manual",
    type: "Installation",
    description: "Complete installation manual for the Nature's View collection.",
    pdf: "/docs/guides/natures-view-installation-manual.pdf",
  },
  {
    title: "Rubber Flooring Installation",
    type: "Installation",
    description: "Guidelines for installing recycled rubber flooring.",
    pdf: "/docs/guides/rubber-flooring-installation.pdf",
  },
  {
    title: "Interlocking Tile Installation",
    type: "Installation",
    description: "Assembly and installation for interlocking rubber tiles.",
    pdf: "/docs/guides/interlocking-tile-installation.pdf",
  },
  {
    title: "Snap Trax Installation",
    type: "Installation",
    description: "Installation instructions for the Snap Trax entry grid system.",
    pdf: "/docs/guides/snap-trax-installation.pdf",
  },

  // ---------- Maintenance ----------
  {
    title: "General Maintenance Guidelines",
    type: "Maintenance",
    description: "Everyday care and maintenance guidelines for van Gelder flooring.",
    pdf: "/docs/guides/general-maintenance-guidelines.pdf",
  },
  {
    title: "Roll & Tile Maintenance",
    type: "Maintenance",
    description: "Maintenance instructions for roll goods and carpet tile.",
    pdf: "/docs/guides/roll-and-tile-maintenance.pdf",
  },
  {
    title: "Mat Storage & Maintenance Guide",
    type: "Maintenance",
    description: "Best practices for storing and maintaining floor mats.",
    pdf: "/docs/guides/mat-storage-maintenance-guide.pdf",
  },
  {
    title: "Frontrunner Cleaning Guide",
    type: "Maintenance",
    description: "Cleaning and care guide for Frontrunner entrance matting.",
    pdf: "/docs/guides/frontrunner-cleaning-guide.pdf",
  },
  {
    title: "Grid & Frontrunner Cleaning",
    type: "Maintenance",
    description: "Cleaning guidance for grid systems and Frontrunner mats.",
    pdf: "/docs/guides/grid-frontrunner-cleaning.pdf",
  },
];

export const guideCountByType = (type) => guides.filter((g) => g.type === type).length;
